import { render, staticRenderFns } from "./HomeBusiness.vue?vue&type=template&id=0b4cb7d4&"
import script from "./HomeBusiness.vue?vue&type=script&lang=js&"
export * from "./HomeBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports